import type { MakeupSearchFilters } from "@/lib/services/makeupService";
import { QueryKeys } from "@/lib/types";

/** Member portal only — admin/teacher queue keeps default mount refetch. */
export const MEMBER_MAKEUP_SESSIONS_STALE_TIME_MS = 60_000;

function toLocalDateKey(value?: Date | string | null): string | null {
  if (value == null) return null;
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function normalizeMakeupSearchFilters(
  filters: MakeupSearchFilters = {},
) {
  return {
    memberId: filters.memberId ?? null,
    studentId: filters.studentId ?? null,
    teacherId: filters.teacherId ?? null,
    locationId: filters.locationId ?? null,
    sourceClassId: filters.sourceClassId ?? null,
    makeupClassId: filters.makeupClassId ?? null,
    sourceAppointmentId: filters.sourceAppointmentId ?? null,
    makeupAppointmentId: filters.makeupAppointmentId ?? null,
    status: filters.status ?? null,
    fromDate: toLocalDateKey(filters.fromDate),
    toDate: toLocalDateKey(filters.toDate),
  };
}

export function getMakeupSessionsQueryKey({
  page,
  pageSize,
  lastSelectedId,
  active,
  filters = {},
}: {
  page: number;
  pageSize: number;
  lastSelectedId?: string;
  active?: boolean;
  filters?: MakeupSearchFilters;
}) {
  return [
    QueryKeys.MakeupSessions,
    page,
    pageSize,
    lastSelectedId,
    active,
    normalizeMakeupSearchFilters(filters),
  ] as const;
}

export function eligibleMakeupAttendanceQueryKey(
  studentIdsKey: string,
  expiryDays: number,
) {
  return [
    QueryKeys.Attendance,
    "eligible-makeup-sessions",
    studentIdsKey,
    expiryDays,
  ] as const;
}
